import { render, staticRenderFns } from "./GameUpload.vue?vue&type=template&id=77d173c2&"
import script from "./GameUpload.vue?vue&type=script&lang=js&"
export * from "./GameUpload.vue?vue&type=script&lang=js&"
import style0 from "./GameUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports